document.addEventListener('DOMContentLoaded', function () {
    const caseStudySections = document.querySelectorAll('.js-section-case-study-block');

    caseStudySections.forEach((section) => {
        const navButtons = section.querySelectorAll('.js-section-case-study-block-nav-button');
        const items = section.querySelectorAll('.js-section-case-study-block-item');
        const indicator = section.querySelector('.js-section-case-study-block-indicator');
        const select = section.querySelector('.js-section-case-study-block-select');

        function updateIndicatorPosition() {
            const activeButton = section.querySelector('.section-case-study-block__nav-button--active');
            if (activeButton) {
                indicator.style.left = `${activeButton.offsetLeft + activeButton.offsetWidth / 2}px`;
            }
        }

        window.addEventListener('resize', updateIndicatorPosition);

        if (select) {
            select.addEventListener('change', function () {
                const index = this.value;

                items.forEach(item => {
                    item.classList.remove('section-case-study-block__item--active');
                });

                navButtons.forEach(btn => {
                    btn.classList.remove('section-case-study-block__nav-button--active');
                });

                const activeItem = items[index];
                activeItem.classList.add('section-case-study-block__item--active');
                navButtons[index].classList.add('section-case-study-block__nav-button--active');
                updateIndicatorPosition();
            });
        }

        navButtons.forEach(button => {
            button.addEventListener('click', function () {
                const index = this.dataset.index;

                items.forEach(item => {
                    item.classList.remove('section-case-study-block__item--active');
                });

                navButtons.forEach(btn => {
                    btn.classList.remove('section-case-study-block__nav-button--active');
                });

                const activeItem = items[index];
                activeItem.classList.add('section-case-study-block__item--active');
                this.classList.add('section-case-study-block__nav-button--active');
                select.value = index; // Update select to match the clicked button
                updateIndicatorPosition();
            });
        });

        // Set initial position of the indicator on load
        updateIndicatorPosition();
    });
});
